function cov_hvuehf4qq() {
  var path = "/app/src/checkout-frame/api/get-entity-id.ts";
  var hash = "55b547b505f1fb44396f631e1ae0187742be79ae";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/checkout-frame/api/get-entity-id.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 22
        },
        end: {
          line: 4,
          column: 37
        }
      },
      "1": {
        start: {
          line: 6,
          column: 27
        },
        end: {
          line: 12,
          column: 1
        }
      },
      "2": {
        start: {
          line: 7,
          column: 19
        },
        end: {
          line: 7,
          column: 57
        }
      },
      "3": {
        start: {
          line: 9,
          column: 2
        },
        end: {
          line: 9,
          column: 39
        }
      },
      "4": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 11,
          column: 18
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 27
          },
          end: {
            line: 6,
            column: 28
          }
        },
        loc: {
          start: {
            line: 6,
            column: 33
          },
          end: {
            line: 12,
            column: 1
          }
        },
        line: 6
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 45
          }
        }, {
          start: {
            line: 7,
            column: 49
          },
          end: {
            line: 7,
            column: 57
          }
        }],
        line: 7
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "55b547b505f1fb44396f631e1ae0187742be79ae"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_hvuehf4qq = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_hvuehf4qq();
import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';
var ENTITY_ID_KEY = (cov_hvuehf4qq().s[0]++, 'xxx111otrckid');
cov_hvuehf4qq().s[1]++;
export var getEntityId = function getEntityId() {
  cov_hvuehf4qq().f[0]++;
  var entityId = (cov_hvuehf4qq().s[2]++, (cov_hvuehf4qq().b[0][0]++, Cookies.get(ENTITY_ID_KEY)) || (cov_hvuehf4qq().b[0][1]++, uuidv4()));
  cov_hvuehf4qq().s[3]++;
  Cookies.set(ENTITY_ID_KEY, entityId);
  cov_hvuehf4qq().s[4]++;
  return entityId;
};